module.exports = __webpack_public_path__ + "img/icon_send.e2986c66.svg";